
import React, { useCallback, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { dismissDsaReviewPopup } from "../../Services/redux/dsa-review/DSAReviewActions";
import "./DSAReviewPopup.css";

export default function DSAReviewPopup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dialogRef = useRef(null);
  const showDsaReviewPopup = useSelector(
    (state) => state.dsaReview.showDsaReviewPopup
  );

  const handleDismiss = useCallback(() => {
    dispatch(dismissDsaReviewPopup());
  }, [dispatch]);

  const handleVerify = useCallback(() => {
    dispatch(dismissDsaReviewPopup());
    navigate("/ui/developer/myprofile", { state: { editMode: true } });
  }, [dispatch, navigate]);

  useEffect(() => {
    if (!showDsaReviewPopup) return;

    const handleClickOutside = (e) => {
      if (dialogRef.current && !dialogRef.current.contains(e.target)) {
        handleDismiss();
      }
    };

    const handleEscapeKey = (e) => {
      if (e.key === "Escape") {
        handleDismiss();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [showDsaReviewPopup, handleDismiss]);

  if (!showDsaReviewPopup || location.pathname.includes("myprofile") || location.pathname.includes("documentation")) {
    return null;
  }

  return (
    <div className="dsa-review-overlay">
      <dialog
        className="dsa-review-dialog"
        aria-labelledby="dsa-review-title"
        aria-modal="true"
        open
        ref={dialogRef}
      >
        <div className="dsa-review-title" id="dsa-review-title">
          <span className="warning-icon">⚠️</span>
          <span>Please Review your Profile / Business Information</span>
        </div>
        <div className="dsa-review-body">
          <p>
            Please verify your profile and complete any missing business
            information. Review the details update any required fields, and save
            your changes to confirm your information.
          </p>
          <p>
            If you have questions, contact HARMAN Partner Support via email.{" "}
            <a
              className="dsa-review-email-link"
              href="mailto:MarketplacePartnerships@harman.com"
            >
              MarketplacePartnerships@harman.com
            </a>
            {"."}
          </p>
        </div>
        <div className="dsa-review-actions">
          <button className="dsa-verify-btn" onClick={handleVerify}>
            Verify Info
          </button>
        </div>
      </dialog>
    </div>
  );
}